import React, { useContext } from 'react';
import { ChatAction, ChatState } from './ChatState';

export function chatReducer(state: ChatState, action: ChatAction): ChatState {
    if (state[action.type] && typeof state[action.type] === 'function') {
        return state[action.type as any](action.payload, ...(action.rest || []));
    }

    return state.set(action.type as any, action.payload);
}

export const ChatContext = React.createContext<ChatState>(new ChatState());
export const ChatContextProvider = ChatContext.Provider;

export const useChatContext = (): ChatState => useContext(ChatContext);
